<template>
    <b-card no-body>
        <b-card-body bg-variant="light" class="w-full d-flex align-items-center gap-2">
            <b-col lg="9">
                <b-form-row @keyup.enter="load" class="flex-wrap align-items-center">
                    <b-col lg="6" sm="12" class="text-left" style="flex: 0 0 calc(50% - 8px)">
                        <LgFinderPageProduto id="finderProdutoLote" @onselect="handleSelectProduto"
                            v-model="form.produto" invalidFeedback="Produto deve ser informado!" :title="` > Produto`"
                            :prefix="prefix + title + ' > '" :disabled="almoxarifado != null || disabled" />
                    </b-col>
                    <b-col lg="6" sm="12" class="text-left" style="flex: 0 0 calc(50% - 8px)">
                        <LgFinderPageAlmoxarifado :disabled="almoxarifado != null || disabled"
                            id="finderAlmoxarifadoLote" @onselect="handleSelectAlmoxarifado" v-model="form.almoxarifado"
                            invalidFeedback="Almoxarifado deve ser informado!" :title="` > Almoxarifado`"
                            :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col lg="3" sm="12" class="text-left">
                        <LgFormConstSelect v-model="form.situacao" classFormGroup="px-0" label="Situação:"
                            :options="form.defaultOptions" @change="load" />
                    </b-col>
                    <b-col class="text-left" style="flex: 1 0 50%">
                        <LgFormInput v-model="form.descricao" label="Descrição:" placeHolder="" description=""
                            invalidFeedback="" />
                    </b-col>
                    <b-col lg="3" sm="12" class="text-left">
                        <b-button id="localizarLote" size="sm" style="height: 20px" pill variant="primary" @click="load"
                            title="Buscar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarLote" title="Localizar"></b-tooltip>
                        </b-button>
                    </b-col> </b-form-row></b-col>
            <b-col lg="3" v-if="temPrivilegioIncluir()" id="novoLote" sm="12"
                class="d-flex align-items-center justify-content-center">
                <b-button size="md" variant="success" v-b-tooltip.hover.top="'Adicionar novo...'" @click="openForm">
                    <b-icon scale="1" icon="plus" />

                </b-button>
            </b-col>
        </b-card-body>

        <b-table class="mt-4" responsive small :busy="busy" :items="safeRecords" :fields="tableFields" hover show-empty
            @row-dblclicked="loteSelect">
            <template #table-busy>
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
            </template>

            <template #empty>
                <p>Nenhum Registro encontrado</p>
            </template>

            <template v-slot:cell(editar)="row">
                <b-button v-b-tooltip.hover.bottom="'Editar...'" :disabled="!temPrivilegioEdicao()" v-if="row.item.inventariando != 1"
                    :id="row.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                    @click="editar(row.item)">
                    <b-icon icon="pencil-square" />
                </b-button>
            </template>

            <template v-slot:cell(situacao)="row">
                <div v-if="row.item.inventariando != 1" :id="row.index + 'ativar'">
                    <b-form-checkbox v-model="row.item.situacao" switch :value="1" :unchecked-value="0"
                        @change="ativaInativa(row.item)" />
                    <b-tooltip :target="row.index + 'ativar'" title="Ativar/Desativar..."></b-tooltip>
                </div>
            </template>



        </b-table>
        <b-row style="margin-top: 12px" v-if="hasRecords">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                    totalPage }}
                    - {{ total }} registros</b-col>
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                    <b-form-select size="sm" v-model="perPage" @change="load" :options="perPageOptions">
                    </b-form-select>
                </b-col>
            </b-col>
            <b-col cols="6">
                <div class="d-flex justify-content-end align-items-end">
                    <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                        :total-rows="total"></b-pagination>
                </div>
            </b-col>
        </b-row>
        <LoteForm :id="id" :prefix="prefix + title + ' > '" v-if="showModalLoteForm" :produto="form.produto"
            :almoxarifado="form.almoxarifado" @close="closeForm" />
    </b-card>
</template>
<script>
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import ResourceService from "@/core/api/ResourceService"
import LoteForm from "./LoteForm.vue"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import ConfirmMixin from "@/core/mixins/confirm"

export default {
    components: {
        LoteForm,
        LgFinderPageProduto,
        LgFinderPageAlmoxarifado,
        LgFormConstSelect,
        LgFormInput,

    },

    props: {
        produto: {
            type: Object,
            default: null,
        },
        almoxarifado: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Lote",
        },
    },
    mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],

    beforeMount() {
        this.$service = new ResourceService("/api/lote")
    },

    mounted() {
        this.form.produto = this.produto
        this.form.almoxarifado = this.almoxarifado
        this.load()
    },

    data() {
        return {
            showModalLoteForm: false,
            records: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            totalPage: 0,
            total: 0,
            page: 1,
            busy: false,
            form: {
                produto: {},
                almoxarifado: {},
                descricao: "",
                situacao: 1,
                defaultOptions: [
                    { value: null, text: "Todos" },
                    { value: 0, text: "Inativos" },
                    { value: 1, text: "Ativos" },
                ],
            },
        }
    },

    methods: {
        async ativaInativa(item) {


            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "inativar") + " o Lote?",
                item.descricao.toUpperCase()
            );

            if (response == true) {
                this.confirmarAtivaInativa(item)
            }
            else
                item.situacao = item.situacao === 1 ? 0 : 1
        },

        async confirmarAtivaInativa(item) {
            this.busy = true;
            const { status } = await this.$service.alteraSituacao(item)
            this.busy = false;

            if (status === 200) {
                this.$notify({
                    type: "success",
                    message: "Registro atualizado com sucesso.",
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: "Erro ao atualizar o registro.",
                })
            }
        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        temPrivilegioIncluir() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

        },

        async load() {
            let filtro = {}
            this.busy = true
            if (this.form.produto && this.form.produto.id) {
                filtro.produtoId = this.form.produto.id
            }
            if (this.form.almoxarifado && this.form.almoxarifado.id) {
                filtro.almoxarifadoId = this.form.almoxarifado.id
            }
            if (this.form.descricao != "") {
                filtro.descricao = this.form.descricao
            }
            if (this.form.situacao) {
                filtro.situacao = this.form.situacao
            }

            await this.$loadResource({
                page: this.page,
                size: this.perPage,
                params: filtro,
            });
            this.busy = false

        },

        handleSelectProduto(produto) {
            this.form.produto = produto
        },

        loteSelect(item) {
            this.$emit("onselect", item)
        },

        handleSelectAlmoxarifado(almoxarifado) {
            this.form.almoxarifado = almoxarifado
        },

        openForm() {
            if (!this.form.produto.id || !this.form.almoxarifado.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione o Produto e o Almoxarifado!",
                })
                return
            }
            this.showModalLoteForm = true
        },

        async editar(lote) {
            console.log(lote)
            this.id = lote.id;
            this.showModalLoteForm = true;
        },


        closeForm() {
            this.showModalLoteForm = false
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                { key: "descricao", label: "Descrição" },
                {
                    key: "editar",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },


            ]
        },

        safeRecords() {
            return this.records || []
        },

        hasRecords() {
            return Array.isArray(this.records) && this.records.length > 0
        },
    },

    watch: {
        page() {
            this.load()
        },


    },
}
</script>
